import { useState } from "react";
import { faqs } from "@/mocks/topics";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <span className="flex items-center gap-2 font-label text-xs font-medium tracking-[0.2em] text-primary-600">
            <i className="ri-question-answer-line"></i>
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于「说法对比」
          </h2>
          <p className="mt-3 font-label text-sm leading-relaxed text-foreground-600">
            我们只做归档和排版，不下结论。下面几个问题，是新读者最常问的。
          </p>
          <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5">
            <p className="flex items-start gap-2 font-label text-sm leading-relaxed text-foreground-700">
              <i className="ri-information-line mt-0.5 flex-none text-accent-700"></i>
              还有别的疑问？在「关于我们」页面可以找到投稿与联系方式。
            </p>
          </div>
        </div>

        <div className="lg:col-span-8">
          <dl className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={faq.q}>
                  <dt>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100"
                      aria-expanded={isOpen}
                    >
                      <span className="font-heading text-base font-semibold text-foreground-950">
                        {faq.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 flex-none items-center justify-center rounded-full transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                  </dt>
                  {isOpen && (
                    <dd className="px-5 pb-5 font-label text-sm leading-relaxed text-foreground-600">
                      {faq.a}
                    </dd>
                  )}
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
}